<div class="message p-4 text-12">
    <ng-content></ng-content>
</div>
